import { v4 as uuidv4 } from "uuid";


export const defaultLinks = [
  {
    id: uuidv4(),
    label: "Instagram",
    url: "https://instagram.com",
    icon: "📸",
  },
  {
    id: uuidv4(),
    label: "YouTube",
    url: "https://youtube.com",
    icon: "📹",
  },
  {
    id: uuidv4(),
    label: "Facebook",
    url: "https://facebook.com",
    icon: "📱",
  },
  {
    id: uuidv4(),
    label: "Twitter",
    url: "https://twitter.com",
    icon: "🐦",
  },
  {
    id: uuidv4(),
    label: "LinkedIn",
    url: "https://linkedin.com",
    icon: "💼",
  },
  {
    id: uuidv4(),
    label: "TikTok",
    url: "https://tiktok.com",
    icon: "🎵",
  },
  {
    id: uuidv4(),
    label: "Snapchat",
    url: "https://snapchat.com",
    icon: "👻",
  },
  {
    id: uuidv4(),
    label: "Pinterest",
    url: "https://pinterest.com",
    icon: "📌",
  },
  {
    id: uuidv4(),
    label: "Reddit",
    url: "https://reddit.com",
    icon: "👾",
  },
  {
    id: uuidv4(),
    label: "WhatsApp",
    url: "https://whatsapp.com",
    icon: "💬",
  },
  {
    id: uuidv4(),
    label: "GitHub",
    url: "https://github.com",
    icon: "🐙",
  },
];

// Define action types for the reducer
export const actionTypes = {
  SET_FIELD: "SET_FIELD",
  SET_LINKS: "SET_LINKS",
  ADD_LINK: "ADD_LINK",
  DELETE_LINK: "DELETE_LINK",
  MOVE_LINK: "MOVE_LINK",
  SET_PROFILE_IMAGE: "SET_PROFILE_IMAGE",
  REMOVE_PROFILE_IMAGE: "REMOVE_PROFILE_IMAGE",
  SET_BACKGROUND_IMAGE: "SET_BACKGROUND_IMAGE",
  REMOVE_BACKGROUND_IMAGE: "REMOVE_BACKGROUND_IMAGE",
};

// Reducer function to handle state updates
export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_FIELD:
      return { ...state, [action.field]: action.value };
    case actionTypes.SET_LINKS:
      return { ...state, links: action.links };
    case actionTypes.ADD_LINK:
      return {
        ...state,
        links: [
          ...state.links,
          { id: uuidv4(), label: "New Link", url: "#", icon: "🔗" },
        ],
      };
    case actionTypes.DELETE_LINK:
      return {
        ...state,
        links: state.links.filter((link) => link.id !== action.id),
      };
    case actionTypes.MOVE_LINK:
      const updatedLinks = [...state.links];
      const [movedLink] = updatedLinks.splice(action.fromIndex, 1);
      updatedLinks.splice(action.toIndex, 0, movedLink);
      return { ...state, links: updatedLinks };
    case actionTypes.SET_PROFILE_IMAGE:
      return { ...state, profileImage: action.profileImage };
    case actionTypes.REMOVE_PROFILE_IMAGE:
      return { ...state, profileImage: "" };
    case actionTypes.SET_BACKGROUND_IMAGE:
      return { ...state, backgroundImage: action.backgroundImage };
    case actionTypes.REMOVE_BACKGROUND_IMAGE:
      return { ...state, backgroundImage: "" };
    default:
      return state;
  }
};

// Initial state for the reducer
export const initialState = {
  links: JSON.parse(localStorage.getItem("socialLinks")) || defaultLinks,
  backgroundImage: localStorage.getItem("backgroundImage") || "",
  profileImage: localStorage.getItem("profileImage") || "",
  bio: "Add a short bio about yourself...",
  profileName: "Your Name",
  profilePosition: "center",
  profileColor: "#000000",
};
